import TourGamesPicksHeader from './TourGramesPicksHeader'
export default TourGamesPicksHeader